import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubArticleEmbedEditorRoute: InvariantJiraRoute = {
	name: 'kb-article-embed-editor',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
	query: ['draftShareId?', 'topicId?'],
};
